import { useLazyGetAuctionForms } from "apollo/hooks/queries";
import { useEnvContext } from "context/EnvContext";
import {
  QUERY_PROGRESS_NOT_STARTED,
  QUERY_PROGRESS_PENDING,
  QUERY_PROGRESS_SUCCEED,
} from "core/consts";
import { activateEligibilityFiles } from "core/model/utils/featureFlags";
import { AllPatientForms, QueryProgress } from "core/types";
import { useEffect, useState } from "react";

export function useGetFormFiles({
  auctionId,
  consultationId,
  isEligiblePage,
  patientId,
  skip,
}: {
  auctionId: number;
  consultationId: number;
  isEligiblePage?: boolean;
  patientId: number;
  skip?: boolean;
}) {
  const { isReceiverApp } = useEnvContext();

  const [formsProgress, setFormsProgress] = useState<QueryProgress>(
    QUERY_PROGRESS_NOT_STARTED,
  );
  const [allForms, setAllForms] = useState<AllPatientForms | undefined>(
    undefined,
  );

  const getAuctionForms = useLazyGetAuctionForms();

  useEffect(() => {
    const shouldLoadForms =
      !skip &&
      activateEligibilityFiles &&
      !isEligiblePage &&
      !isReceiverApp &&
      auctionId &&
      !consultationId;

    if (!shouldLoadForms) {
      setFormsProgress(QUERY_PROGRESS_NOT_STARTED);
      setAllForms(undefined);
      return;
    }

    const loadForms = async () => {
      setFormsProgress(QUERY_PROGRESS_PENDING);

      try {
        const auctionForms = await getAuctionForms({ auctionId });
        setAllForms({ auctionForms });
        setFormsProgress(QUERY_PROGRESS_SUCCEED);
      } catch (error) {
        console.error("Error loading forms:", error);
        setFormsProgress(QUERY_PROGRESS_NOT_STARTED);
      }
    };

    loadForms();
  }, [
    skip,
    activateEligibilityFiles,
    isEligiblePage,
    isReceiverApp,
    auctionId,
    patientId,
  ]);

  return {
    allForms,
    getFormsProgress: formsProgress,
  };
}
